import {
    Button as MuiButton,
    createStyles,
    Theme,
    Typography,
    withStyles,
    WithStyles,
} from "@material-ui/core";
import { SxProps } from "@material-ui/system";
import classNames from "classnames";
import React from "react";
import { commonClasses } from "../styles";
import { colors } from "../theme";

const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
        button: (props: PureProps) => {
            const background =
                props.variant === "flat"
                    ? "unset"
                    : props.color === "blue"
                    ? `linear-gradient(${colors.brand.blue.main}, ${colors.brand.blue.light})`
                    : props.color === "whatsApp"
                    ? colors.thirdParty.whatsApp
                    : "linear-gradient(#ffffff,#ffffff) padding-box, linear-gradient(to bottom, #23829F, #0B4C61) border-box";
            const padding = props.variant === "dull" ? "2px 10px" : "2px 4px";
            return {
                paddingRight: "8px",
                border:
                    props.variant === "flat"
                        ? "none"
                        : `1.5px solid ${props.color === "whatsApp" ? "white" : ""}`,
                padding,
                borderRadius: "8px",
                background,
                color:
                    props.color && ["blue", "whatsApp"].includes(props.color)
                        ? theme.palette.common.white
                        : "#0B4C61",
                "&:hover": {
                    background,
                },
            };
        },
        large: {
            "& $label .MuiTypography-root": {
                fontSize: "1rem",
            },
            "& $startIcon svg": {
                fontSize: "24px",
            },
        },
        dull: {
            color: "#888C8D",
            borderColor: "#B7BFC1",
        },
        label: {
            pointerEvents: "none",
        },
        startIcon: { marginLeft: 0, marginRight: 0 },
        icon: {
            color: colors.brand.blue.main,
        },
        shareGrid: { paddingTop: "25px" },
        buttonText: (props: PureProps) => {
            return props.color !== "blue"
                ? {
                      fontWeight: "bold",
                      fontSize: "14px",
                      background: "-webkit-linear-gradient(#23829F, #0B4C61)",
                      "-webkit-background-clip": "text",
                      "-webkit-text-fill-color": "transparent",
                  }
                : { marginLeft: "4px" };
        },
    });

type PureProps = {
    id?: string;
    startIcon?: React.ReactNode;
    iconClass?: string;
    variant?: "normal" | "dull" | "flat";
    color?: "normal" | "blue" | "whatsApp";
    textVariant?: "button2" | "button";
    gaEventCategory?: string;
    gaEventAction?: string;
    sx?: SxProps<Theme>;
    large?: boolean;
    onClick?: () => void;
};

type Props = React.PropsWithChildren<WithStyles<typeof styles> & PureProps>;

class Component extends React.Component<Props> {
    render = () => {
        const {
            id,
            classes,
            children,
            variant,
            sx,
            startIcon,
            iconClass,
            textVariant,
            gaEventCategory,
            gaEventAction,
            large,
            onClick,
        } = this.props;
        return (
            <MuiButton
                id={id}
                variant={variant === "normal" ? "contained" : undefined}
                sx={sx}
                className={classNames(classes.button, {
                    [classes.dull]: variant === "dull",
                    [classes.large]: large,
                })}
                classes={{
                    startIcon: classNames(classes.startIcon, iconClass),
                    label: classes.label,
                }}
                startIcon={startIcon}
                onClick={onClick}
                data-ga-event-category={gaEventCategory}
                data-ga-event-action={gaEventAction}>
                <Typography
                    align="center"
                    variant={textVariant || "button"}
                    className={classNames(classes.buttonText)}>
                    {children}
                </Typography>
            </MuiButton>
        );
    };
}

const Button = withStyles(styles)(Component);

export default Button;
